var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 5.83334L10.8408 10.6058C10.5866 10.7535 10.2978 10.8313 10.0038 10.8313C9.70972 10.8313 9.42093 10.7535 9.16667 10.6058L1.66667 5.83334",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 3.33334H3.33334C2.41286 3.33334 1.66667 4.07954 1.66667 5.00001V15C1.66667 15.9205 2.41286 16.6667 3.33334 16.6667H16.6667C17.5871 16.6667 18.3333 15.9205 18.3333 15V5.00001C18.3333 4.07954 17.5871 3.33334 16.6667 3.33334Z",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/IconMail.3436fc80950d12c57a2a6ed469da5f6e.svg";
export { ForwardRef as ReactComponent };